<div [class.dark-theme]="true" class="fix-action-dialog">
	<div class="fix-action-dialog">
		<h2 mat-dialog-title style="font-size: 24px;color:#ffffff;font-weight: 600;"><span translate>メールアドレスの変更</span></h2>
		<h2 mat-dialog-title style="font-size: 14px;color:#ffffff;font-weight: 600;"><span translate>現在のメールアドレス</span>：{{content.username}}</h2>
	</div>
	<mat-dialog-content fxLayout="column">
		<mat-card>
			<mat-card-content>
				<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
					<mat-form-field appearance="outline" style="margin:6px;height: 80px;">
						<mat-label><span translate>ユーザ名</span></mat-label>
						<input data-idtest="guest-username-dialog-i-1Jt" #username="ngModel" [(ngModel)]="content.username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username" placeholder="{{'ユーザ名'| translate}}" required type="email">
						<mat-error *ngIf="username.errors?.['email'];"><span translate>有効なメールアドレスを入力してください</span></mat-error>
						<mat-error *ngIf="username.errors?.['required'];"><span translate>入力してください</span></mat-error>
						<mat-error *ngIf="username.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
						<mat-error *ngIf="username.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
					</mat-form-field>
				</form>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around" style="margin:6px;">
		<button data-idtest="guest-username-dialog-b-0Qt" color="warn" mat-dialog-close="" mat-stroked-button id="mat-cancel-button">キャンセル</button>
		<button (click)="onAccept()" [disabled]="form.invalid" color="primary" mat-raised-button id="mat-ok-button"><span translate>更新</span></button>
	</mat-dialog-actions>
</div>
